<div class="layout__inner-card layout--full-height">
  <h4 i18n>Rappel du besoin</h4>
  <p i18n>Le client a besoin d’un total de couverture d’assurance vie de</p>

  <p class="card__needs"
    ><strong>{{ needs | currency }}</strong></p
  >
</div>
